exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "tr td {\r\n    height: 10px;\r\n    padding: 0.2rem;\r\n}\r\n\r\n.row {\r\n    margin-left: 0 !important;\r\n    margin-right: 0 !important;\r\n}\r\n\r\n.ng-option {\r\n    height: auto !important;\r\n}\r\n\r\n.ng-select.custom ::ng-deep .ng-value {\r\n    color: #2D5586;\r\n    font-weight: bold;\r\n}\r\n\r\n.infoIcon {\r\n    position: relative;\r\n    float: right;\r\n    margin-top: 0.3rem;\r\n  }\r\n\r\n.tooltiptext {\r\n    width: -webkit-fit-content;\r\n    width: -moz-fit-content;\r\n    width: fit-content;\r\n    text-wrap:wrap;\r\n    background-color: white;\r\n    color: black;\r\n    text-align: left;\r\n    border-radius: 6px;\r\n    padding: 0.5rem;\r\n    position: absolute;\r\n    z-index: 1;\r\n    border: 1px solid #dee2e6;\r\n    right: 0.5rem;\r\n    bottom: 1rem;\r\n  }", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/TeamCity/BuildAgent3/work/c38c6eefb6a115e8/HSG.Accounting/HSG.Accounting.MonitoringMobileApp/src/app/unpaid/unpaid.component.css
// module id = ../../../../../src/app/unpaid/unpaid.component.css
// module chunks = main